export default "__VITE_ASSET__edc966b0__"